import { withInstall } from '@vuemap/vue-amap-util'
import SearchBox from './SearchBox.vue'

export const ElAmapSearchBox = withInstall(SearchBox)
export default ElAmapSearchBox
